import { connect } from 'react-redux';
import { STANDARD_SUBSCRIPTION_PRICE_MONTHLY, STANDARD_SUBSCRIPTION_ADDITIONAL_USER_PRICE_MONTHLY, ADDITIONAL_USER_DESCRIPTION, } from '../actions/types';

import Tooltip from './Tooltip';
import PushButton from './PushButton';

import ChecklistIcon from '../icons/checklistIcon';

const StandardSubscriptionCard = ({ onClicked }) => {
  return (
    <div className='flex flex-col border w-full md:w-[350px] border-[#aaa] py-4 px-6 rounded-lg bg-[#00000066]'>
      <div className='flex text-[1.6em] font-bold'>Standard</div>
      <div className='h-[75px] text-base'>Everything you need for your entire team.</div>
      <div className='flex flex-col h-[75px] mt-[10px]'>
        <div className='flex justify-start items-end gap-1'>
          <div className='text-[1.6em] leading-[1.2em] font-bold text-[#f9a928]'>${STANDARD_SUBSCRIPTION_PRICE_MONTHLY}</div>
          <div className='opacit-80'>/</div>
          <div className='opacit-80'>month</div>
        </div>
      </div>
      <button 
        className='w-full font-bold p-[10px] border border-[#f9a928] hover:bg-[#f9a928] hover:text-black mr-2 rounded-lg'
        onClick={() => { 
          try {
            onClicked();
          } catch(error) {}
        }}
      >
        Start Standard Version
      </button>
      <div className='mt-[40px] mb-[20px] text-sm font-bold'>EVERYTHING IN TRIAL PLUS:</div>
      <div className='flex items-center gap-x-2'>
        <ChecklistIcon size='16' color='#55fa79' />
        <div>Unlimited projects</div>
      </div>
      <div className='flex flex-col items-start gap-x-2'>
        <div className='flex items-center gap-x-2'>
          <ChecklistIcon size='16' color='#55fa79' />
          <div className='flex gap-2'>
            <div>Unlimited</div>
            <Tooltip tooltipContent={ADDITIONAL_USER_DESCRIPTION}>
              <div className='underline decoration-dotted underline-offset-4 cursor-help'>additional users</div>
            </Tooltip>
          </div>
        </div>
        <div className='flex gap-2'>
          <div className='opacity-0'><ChecklistIcon size='16' color='#55fa79' /></div>
          <div>for <span className='text-[#f9a928]'>$5</span>/user/month</div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => { return {
}};
export default connect(mapStateToProps, { })(StandardSubscriptionCard);
